import { Button } from "../../../../components/ui/button";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "../../../../components/ui/input-otp";
import { useStepper } from "../../../../components/ui/stepper";
import React, { useState } from "react";
import { post } from "../../../../config";
import GoogleAuth from "../../../../assets/images/authenticator.png";
import MicroAuth from "../../../../assets/images/microsoft-authenticator.png";

const Step2 = ({ verifyUrl, setLoading }) => {
  const [verifyCode, setVerifyCode] = useState("");
  const [validator, setValidator] = useState(false);
  const { nextStep, prevStep } = useStepper();

  const changeAuthenticationCode = (event) => {
    if (validator) {
      setValidator(false);
    }
    setVerifyCode(event);
  };

  const confirmCode = async (e) => {
    e.preventDefault();
    let params = {};
    if (verifyUrl === "/disable-2fa") {
      params = { code: verifyCode, id: 1 };
    } else {
      params = { code: verifyCode };
    }
    setLoading(true);
    post(verifyUrl, params)
      .then(() => {
        setValidator(false);
        nextStep();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setValidator(true);
      });
  };

  return (
    <form
      onSubmit={confirmCode}
      className="flex flex-col items-center justify-center"
    >
      <p className="pb-3 flex items-center">
        Open your{" "}
        <span className="flex gap-1 items-center pr-1">
          <img alt="authenticator" src={GoogleAuth} width={30} height={30} />
          <span className="pr-1">|</span>
          <img alt="authenticator" src={MicroAuth} width={30} height={30} />
        </span>
        Authenticator app.
      </p>
      <p className="pb-3">
        Enter the 6-digit code found from your authenticator app
      </p>
      <div className="flex flex-col items-center justify-center pb-3">
        <InputOTP
          maxLength={6}
          onChange={(e) => changeAuthenticationCode(e)}
          name="code"
          id="code"
          value={verifyCode}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
          </InputOTPGroup>
          <InputOTPSeparator />
          <InputOTPGroup>
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>
      </div>
      <div className="flex gap-2">
        <Button type="submit">Confirm</Button>
        <Button variant="outline" size="default" onClick={() => prevStep()}>
          Back
        </Button>
      </div>
    </form>
  );
};

export default Step2;
